import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<{ fullWidth: boolean }>()(
  (theme, { fullWidth }) => ({
    root: {
      width: fullWidth ? '100%' : 'auto',
      margin: 0,
      position: 'relative',
      backgroundColor: 'transparent',

      '& .MuiOutlinedInput-root': {
        padding: '6px !important',
        backgroundColor: 'transparent',

        '& input[type=number]': {
          MozAppearance: 'textfield',
          WebkitAppearance: 'none',
        },
        '& input::-webkit-outer-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },

        '& input::-webkit-inner-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent !important',
          // '&:hover': {
          // },
        },
      },
      '& .MuiTooltip-tooltip': {
        maxWidth: '200px',
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText,
      },
    },
    viewModeWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    infoButton: {
      padding: theme.spacing(0.5),
      position: 'absolute',
      right: '4px',
      top: '7px',
      '& svg': {
        width: '16px',
        height: '16px',
        color: theme.palette.error.main,
      },
    },
  }),
);
